"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootReducer = void 0;
const redux_1 = require("redux");
const config = require("./config/reducers");
const workspaces = require("./workspaces/reducers");
const session = require("./session/reducers");
const me = require("./me/reducers");
const entities = require("./entities/reducers");
const plugins = require("./plugins/reducers");
// eslint-disable-next-line @rushstack/typedef-var
exports.rootReducer = redux_1.combineReducers({
    entities: entities.default,
    config: config.default,
    workspaces: workspaces.default,
    session: session.default,
    me: me.default,
    plugins: plugins.default
});
//# sourceMappingURL=reducers.js.map